/**
 * Polish plural form for a count: pluralPl(1, ['sekundę', 'sekundy', 'sekund'])
 * → 'sekundę'; 2–4 (except 12–14) take the second form, the rest the third.
 */
export function pluralPl(count, forms) {
    const n = Math.abs(Math.trunc(Number(count) || 0));
    if (n === 1) return forms[0];
    const last = n % 10;
    const lastTwo = n % 100;
    if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) return forms[1];
    return forms[2];
}
